(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["nether-gallery-rail"] && !Shopify.designMode) return;
  try {
    (function () {
    var MQ = '(min-width: 750px)';

    function init() {
      var rail = document.querySelector('[data-nether-rail]');
      var frame = document.querySelector('media-gallery.media-gallery--grid');
      if (!rail || !frame) return;

      var thumb = rail.querySelector('[data-nether-rail-thumb]');
      var track = rail.querySelector('[data-nether-rail-track]');
      var up = rail.querySelector('[data-nether-rail-up]');
      var down = rail.querySelector('[data-nether-rail-down]');
      if (!thumb || !track || !up || !down) return;

      var desktop = window.matchMedia(MQ);

      /* Visible items only. Per-colourway filtering hides the other colours'
         photos with [hidden], and stepping through hidden items would look like
         the chevron had simply stopped working. */
      function items() {
        var all = frame.querySelectorAll('.product-media-container');
        var out = [];
        for (var i = 0; i < all.length; i++) {
          if (!all[i].hidden && all[i].offsetParent !== null) out.push(all[i]);
        }
        return out;
      }

      function scrollable() {
        return frame.scrollHeight - frame.clientHeight;
      }

      function render() {
        if (!desktop.matches) { rail.hidden = true; return; }

        var max = scrollable();
        /* Under ~4px of travel there is nothing to indicate. Hiding beats
           showing a full-length thumb that cannot move. */
        if (max < 4) { rail.hidden = true; return; }
        rail.hidden = false;

        var ratio = frame.clientHeight / frame.scrollHeight;
        var trackH = track.clientHeight;
        /* Floor the thumb so it stays visible and grabbable in a long gallery
           where the true proportion would be a few pixels. */
        var thumbH = Math.max(24, Math.round(trackH * ratio));
        thumb.style.height = thumbH + 'px';

        var progress = frame.scrollTop / max;
        var travel = trackH - thumbH;
        thumb.style.transform = 'translateY(' + Math.round(progress * travel) + 'px)';

        up.disabled = frame.scrollTop <= 1;
        down.disabled = frame.scrollTop >= max - 1;
      }

      /* One step = one media item. Reads the NEXT item's real offset rather
         than assuming a fixed row height: the grid is two columns with a
         large-first-image option, so rows are not all the same height. */
      function step(dir) {
        var list = items();
        if (!list.length) return;

        var top = frame.scrollTop;
        var target = null;

        if (dir > 0) {
          for (var i = 0; i < list.length; i++) {
            if (list[i].offsetTop > top + 2) { target = list[i]; break; }
          }
          if (!target) target = list[list.length - 1];
        } else {
          for (var j = list.length - 1; j >= 0; j--) {
            if (list[j].offsetTop < top - 2) { target = list[j]; break; }
          }
          if (!target) target = list[0];
        }

        var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        frame.scrollTo({ top: target.offsetTop, behavior: reduced ? 'auto' : 'smooth' });
      }

      up.addEventListener('click', function () { step(-1); });
      down.addEventListener('click', function () { step(1); });

      /* passive: the handler only reads and writes a transform, never calls
         preventDefault, so telling the browser that keeps the scroll on the
         compositor. */
      frame.addEventListener('scroll', render, { passive: true });
      window.addEventListener('resize', render);
      window.addEventListener('load', render);
      if (desktop.addEventListener) desktop.addEventListener('change', render);

      /* The colourway swap changes which photos are visible with no page load,
         which changes scrollHeight and therefore the thumb. Horizon also morphs
         this section outright on variant change. Observing the frame covers
         both without having to know which fired.

         SIGNATURE-GATED, and this is the whole reason the observer is not just
         "on any mutation, reset and re-render". The frame mutates constantly
         for reasons that have nothing to do with the colourway: images swap
         their loading attribute, the theme toggles classes, lazy media resolves
         its src. An ungated observer reset scrollTop to 0 on every one of those,
         so the frame snapped back to the top the instant anyone scrolled it and
         the thumb never left 0. Measured, not theorised.

         So: recompute the visible set, compare it to the last one, and only
         reset scroll when it ACTUALLY changed. Everything else just re-renders
         the thumb, which is cheap and correct. */
      var lastSignature = '';

      function signature() {
        var list = items();
        var s = list.length + ':';
        for (var i = 0; i < list.length; i++) s += (list[i].id || i) + ',';
        return s;
      }

      lastSignature = signature();

      if ('MutationObserver' in window) {
        var pending = false;
        new MutationObserver(function () {
          /* Coalesce a burst of mutations into one measurement. */
          if (pending) return;
          pending = true;
          requestAnimationFrame(function () {
            pending = false;
            var sig = signature();
            if (sig !== lastSignature) {
              lastSignature = sig;
              frame.scrollTop = 0;
            }
            render();
          });
        }).observe(frame, { childList: true, subtree: true, attributes: true, attributeFilter: ['hidden'] });
      }

      render();
      requestAnimationFrame(render);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
